module.exports = __webpack_public_path__ + "img/KGoldpica.1c361c2e.png";